// Composant Logo PCG interactif by KEYTO — favicon KEYTO + wordmark
// Affiche le favicon (carré arrondi) à gauche, suivi du nom de l'application.

export default function Logo({ size ="md", onClick }) {
  const sizeMap = {
    sm: { icon: 22, text:"text-sm", sub:"text-[10px]" },
    md: { icon: 32, text:"text-base", sub:"text-[11px]" },
    lg: { icon: 42, text:"text-lg", sub:"text-xs" },
    xl: { icon: 56, text:"text-xl", sub:"text-sm" },
  };
  const s = sizeMap[size] || sizeMap.md;

  return (
    <button
      data-testid="logo-pc-keyto"
      onClick={onClick}
      className="inline-flex items-center gap-2.5 group max-w-full text-left"
      aria-label="PCG interactif by KEYTO — Retour à l'accueil"
    >
      <img
        src={`${process.env.PUBLIC_URL ||""}/keyto-favicon.png`}
        alt="KEYTO"
        width={s.icon}
        height={s.icon}
        style={{ width: s.icon, height: s.icon }}
        className="rounded-lg shadow-sm shrink-0 select-none transition-transform group-hover:scale-[1.04]"
        draggable="false"
      />
      <div className="flex flex-col leading-tight min-w-0">
        <span className={`font-heading font-extrabold text-[#15294F] tracking-tight ${s.text} truncate`}>
          PCG interactif
        </span>
        <span className={`text-slate-500 font-medium ${s.sub} tracking-wide`}>
          by <span className="text-[#15294F] font-bold">KEYTO</span>
        </span>
      </div>
    </button>
  );
}
